module.exports = __webpack_public_path__ + "img/sonic.d94db7ce.gif";